import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { titleCaseFormatter } from '../utils/stringFormatters';
import fastforward from '../../src/icons/fastforward.png';
import bolt from '../../src/icons/power.svg';
import { isEmpty } from 'lodash';

export default function SelectableTiles({
  dropdownValues,
  icon,
  prefix = '',
  onChange,
  type = 'text',
  defaultValue,
  placeholder = '',
  showPriorityFee = false,
}) {
  const [options, setOptions] = useState(dropdownValues || []);
  const [selected, setSelected] = useState(null);
  const onDropdownChange = (option) => {
    if (option?.id !== selected?.id) {
      setSelected(option);
      onChange(option);
    }
  };
  useEffect(() => {
    setOptions(dropdownValues);
  }, [dropdownValues]);
  // useEffect(() => {
  //   if (defaultValue) {
  //     onDropdownChange(defaultValue);
  //   }
  // }, [defaultValue]);

  useEffect(() => {
    if (defaultValue) {
      setSelected(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className=''>
      {options?.map((item, itemIdx) => (
        <div
          key={itemIdx}
          className={`${
            item?.disabled ? 'cursor-not-allowed opacity-50 ' : 'cursor-pointer '
          } mb-1.5 w-full rounded-lg border-2 bg-[#f5f5fb] p-2 px-5 text-sm font-medium ${
            item?.id === selected?.id ? '  border-client-300' : ' border-[#f5f5fb]'
          }`}
          value={item}
          onClick={() => onDropdownChange(item)}
          disabled={item?.disabled}
        >
          <div className='flex'>
            <span className={`block truncate ${item?.id === selected?.id ? 'font-medium' : 'font-medium'}`}>
              {`${item?.value}`}
            </span>
            {item?.is_rush && (
              <span>
                <img src={bolt} alt='tick' className=' ml-1 mt-1 h-[14px] w-[14px]' />
              </span>
            )}
            {item?.is_rush && (
              <span className={`text-client-300 block truncate font-medium`}>{`+${item?.priority_fee}`}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
